import React from 'react'

const ZoomOut = () => (
  <svg width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 12h18v2H3V3z" />
  </svg>
)

export default ZoomOut
